import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-help",
  "use": "icon-help-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-help\"><g transform=\"translate(2 2)\" fill=\"transparent\" stroke=\"currentColor\"><path d=\"M13 8a3 3 0 00-6 0\" stroke-width=\"1.5\" /><circle fill=\"currentColor\" cx=\"10\" cy=\"15\" r=\"1\" /><circle stroke-width=\"1.5\" cx=\"10\" cy=\"10\" r=\"9.25\" /><path d=\"M13 8c0 .616-.333 1.116-1 1.5-1 .576-2 1.196-2 1.89v2.114\" stroke-width=\"1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol